export const LEGACY_SEARCH_BAR_PACKAGE_SELECTOR = '.logged-out-homepage .search-bar-package';
